/* "Email me this quote": a checkbox under the order total. Checking it opens name, work email and company,
   sends the current order as a quote to HubSpot, so the buyer can share it for approval. */
(function () {
  var C = window.SFG || {};
  var hs = C.hubspot || {};
  var cfg = { portalId: hs.quotePortalId || hs.portalId, formId: hs.quoteFormId, region: hs.region || 'na1' };
  function $(id) { return document.getElementById(id); }
  function track(ev, d) { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: ev }, d || {})); }
  function cookie(n) { var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : undefined; }
  function summary() {
    var rows = [], items = [], seats = 0, courses = [];
    document.querySelectorAll('#sfg-lines .sfg-row').forEach(function (r) {
      var inp = r.querySelector('input[data-key]'), q = parseInt(inp && inp.value, 10) || 0; if (!q) return;
      var name = (r.querySelector('.sfg-row__name span') || {}).textContent || '';
      var per = (r.querySelector('.sfg-line__per strong') || {}).textContent || '';
      var tot = (r.querySelector('.sfg-line__total') || {}).textContent || '';
      if (!per) return; /* line not valid yet */
      rows.push(name + ': ' + q + ' seats x ' + per + ' = ' + tot); seats += q;
      items.push({ name: name.trim(), seats: q, price_each: per.trim(), line_total: tot.trim() });
      var code = (name.match(/BLS|ACLS|PALS|MAB|EKG/i) || [name])[0].toUpperCase(); if (courses.indexOf(code) < 0) courses.push(code);
    });
    return { rows: rows, items: items, seats: seats, courses: courses, total: ($('sfg-total') || {}).textContent || '' };
  }
  /* Klaviyo sends the branded quote email (flow trigger: "Group Quote Requested"). */
  function klaviyo(s, p) {
    var key = (C.klaviyo || {}).publicKey || 'TaGFxJ';
    var exp = new Date(Date.now() + 30 * 864e5);
    var body = { data: { type: 'event', attributes: {
      metric: { data: { type: 'metric', attributes: { name: 'Group Quote Requested' } } },
      profile: { data: { type: 'profile', attributes: {
        email: p.email, first_name: p.first, last_name: p.last, organization: p.company,
        properties: { customer_type: 'B2B group', group_buyer_timezone: p.tz }
      } } },
      properties: {
        QuoteItems: s.items, SeatCount: s.seats, Courses: s.courses, QuoteTotal: s.total.trim(),
        Company: p.company, FirstName: p.first, QuoteUrl: quoteUrl(s),
        ValidUntil: exp.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
      },
      value: parseFloat(s.total.replace(/[$,]/g, '')) || 0, value_currency: 'USD'
    } } };
    return fetch('https://a.klaviyo.com/client/events/?company_id=' + key, {
      method: 'POST', headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' }, body: JSON.stringify(body)
    }).catch(function () {});
  }
  /* Link back to this page with the same seats filled in, e.g. ?q=bls:10,acls:5#sfg-builder.
     Keeps ?view= so the preview link also works. */
  function quoteUrl(s) {
    var u = new URL(location.href), keep = u.searchParams.get('view'), out = new URL(u.origin + u.pathname);
    if (keep) out.searchParams.set('view', keep);
    var th = (window.Shopify || {}).theme; /* unpublished theme: keep the link on this preview */
    if (th && th.role && th.role !== 'main') out.searchParams.set('preview_theme_id', th.id);
    var q = [];
    document.querySelectorAll('#sfg-lines input[data-key]').forEach(function (i) {
      var n = parseInt(i.value, 10) || 0; if (n) q.push(i.getAttribute('data-key').replace(/^group-|-seats$/g, '') + ':' + n);
    });
    if (q.length) out.searchParams.set('q', q.join(','));
    return out.toString() + '#sfg-builder';
  }
  /* Opening a quote link: fill the seats from ?q= and jump to the order box. */
  function prefill(tries) {
    var q = new URLSearchParams(location.search).get('q'); if (!q) return;
    var inputs = document.querySelectorAll('#sfg-lines input[data-key]');
    if (!inputs.length) { if (tries < 40) setTimeout(function () { prefill(tries + 1); }, 100); return; }
    var want = {}; q.split(',').forEach(function (p) { var a = p.split(':'); if (a[0]) want['group-' + a[0] + '-seats'] = parseInt(a[1], 10) || 0; });
    var openMore = false;
    /* set the larger counts first so add-on pricing applies to the small ones */
    var list = Array.prototype.slice.call(inputs).sort(function (a, b) { return (want[b.getAttribute('data-key')] || 0) - (want[a.getAttribute('data-key')] || 0); });
    list.forEach(function (i) {
      var n = want[i.getAttribute('data-key')] || 0; i.value = n || '';
      if (n && i.closest('#sfg-more-list')) openMore = true;
      i.dispatchEvent(new Event('input', { bubbles: true }));
    });
    if (openMore) { var mb = $('sfg-more'), ml = $('sfg-more-list'); if (mb && ml && ml.hasAttribute('hidden')) mb.click(); }
    var b = $('sfg-builder'); if (b) setTimeout(function () { b.scrollIntoView({ block: 'start' }); }, 50);
    track('group_quote_return', { items: q });
  }
  function start() {
    var open = $('sfg-quote-open'), box = $('sfg-quote'), form = $('sfg-quote-form'), msg = $('sfg-quote-msg');
    if (!open || !box || !form) return;
    open.addEventListener('change', function () {
      if (!open.checked) { box.hidden = true; return; }
      var s = summary();
      if (!s.rows.length) { msg.textContent = 'Add seats above first, then we can email your quote.'; box.hidden = false; form.hidden = true; open.checked = false; return; }
      box.hidden = false; form.hidden = false; msg.textContent = '';
      var e = $('sfg-quote-name'); if (e) e.focus();
      track('group_quote_open');
    });
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (!form.reportValidity()) return;
      var s = summary(); if (!s.rows.length) { msg.textContent = 'Add seats above first, then we can email your quote.'; return; }
      var quote = s.rows.join('\n') + '\nTotal: ' + s.total;
      var seg = s.seats > 25 ? '26+' : s.seats >= 20 ? '20-25' : s.seats >= 10 ? '10-19' : '6-9';
      var fields = [
        { objectTypeId: '0-1', name: 'firstname', value: $('sfg-quote-name').value.trim().split(' ')[0] },
        { objectTypeId: '0-1', name: 'lastname', value: $('sfg-quote-name').value.trim().split(' ').slice(1).join(' ') },
        { objectTypeId: '0-1', name: 'email', value: $('sfg-quote-email').value },
        { objectTypeId: '0-1', name: 'company', value: $('sfg-quote-company').value },
        { objectTypeId: '0-1', name: 'group_seat_estimate', value: String(s.seats) },
        { objectTypeId: '0-1', name: 'group_course_interest', value: s.courses.join(';') },
        { objectTypeId: '0-1', name: 'group_size_segment', value: seg },
        { objectTypeId: '0-1', name: 'group_quote_summary', value: quote },
        { objectTypeId: '0-1', name: 'group_quote_total', value: String(parseFloat(s.total.replace(/[$,]/g, '')) || 0) },
        { objectTypeId: '0-1', name: 'group_lead_type', value: 'Quote request' },
        { objectTypeId: '0-1', name: 'group_buyer_timezone', value: (Intl.DateTimeFormat().resolvedOptions().timeZone || '') }
      ];
      var nm = $('sfg-quote-name').value.trim().split(' ');
      klaviyo(s, { email: $('sfg-quote-email').value.trim(), first: nm[0], last: nm.slice(1).join(' '),
        company: $('sfg-quote-company').value.trim(), tz: (Intl.DateTimeFormat().resolvedOptions().timeZone || '') });
      var done = function () {
        form.hidden = true; msg.textContent = 'Sent! Check your inbox for your quote. You can still check out anytime.';
        track('group_quote_submit', { seats: s.seats, value: parseFloat(s.total.replace(/[$,]/g, '')) || 0 });
      };
      if (!cfg.portalId || !cfg.formId) { done(); return; } /* preview: no HubSpot IDs yet */
      var ctx = { pageUri: location.href.split('?')[0], pageName: document.title }; var tk = cookie('hubspotutk'); if (tk) ctx.hutk = tk;
      var host = cfg.region === 'eu1' ? 'https://api-eu1.hsforms.com' : 'https://api.hsforms.com';
      var btn = form.querySelector('[type=submit]'); btn.disabled = true; btn.textContent = 'Sending…';
      fetch(host + '/submissions/v3/integration/submit/' + cfg.portalId + '/' + cfg.formId, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ fields: fields, context: ctx })
      }).then(function (r) { if (!r.ok) throw r; done(); })
        .catch(function () { btn.disabled = false; btn.textContent = 'Email My Quote'; msg.textContent = 'Something went wrong. Please try again.'; });
    });
  }
  function boot() { start(); prefill(0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
